var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163310",
    "data-name": "Group 163310",
    transform: "translate(-62 -167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3224",
    "data-name": "Rectangle 3224",
    transform: "translate(62 167)",
    fill: "#fff",
    stroke: "rgba(97,97,97,0.64)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "zidingyiheng",
    d: "M136.288,152.175h.013c.015,0,1.455-.022,3.583-.026a2.767,2.767,0,1,0,.007-1.532c-2.145,0-3.6.026-3.616.026a.766.766,0,0,0,.013,1.532Zm6.259-2.016a1.237,1.237,0,1,1-1.237,1.237,1.238,1.238,0,0,1,1.237-1.237Zm4.6,2h7.605a.766.766,0,1,0,0-1.532H147.15a.766.766,0,1,0,0,1.532Zm7.638,5.141c-.024,0-.569-.024-2.541-.028a2.767,2.767,0,1,0,.009,1.532c1.906,0,2.456.026,2.469.026h.033a.765.765,0,0,0,.031-1.53Zm-5.2,1.989a1.237,1.237,0,1,1,1.237-1.237A1.238,1.238,0,0,1,149.59,159.292Zm-4.557-2h-8.746a.766.766,0,0,0,0,1.532h8.746a.766.766,0,0,0,0-1.532Zm-2.486,5.106a2.773,2.773,0,0,0-2.657,1.989c-2.145,0-3.6.026-3.616.026a.766.766,0,0,0,.013,1.532h.013c.015,0,1.455-.022,3.583-.026a2.769,2.769,0,1,0,2.663-3.521Zm0,4.005a1.237,1.237,0,1,1,1.237-1.237,1.238,1.238,0,0,1-1.237,1.237Zm12.208-2H147.15a.766.766,0,0,0,0,1.532h7.605a.766.766,0,1,0,0-1.532Z",
    transform: "translate(-67.521 24.373)",
    fill: "#444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.513249606d52a16a21e7e99645b47d65.svg";
export { ForwardRef as ReactComponent };